import script from "./PayoutListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayoutListView.vue?vue&type=script&lang=ts&setup=true"

import "./PayoutListView.vue?vue&type=style&index=0&id=47b19b2d&lang=scss"

const __exports__ = script;

export default __exports__